export default "__VITE_ASSET__CIFKrpCM__"